exports.components = {
  "component---src-pages-dn-42-jsx": () => import("./../../../src/pages/dn42.jsx" /* webpackChunkName: "component---src-pages-dn-42-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */)
}

